import keycloakService from '../../keycloak_service';

import { sinatraOrigin } from '../../config';
import { get_schedule_request } from '../../components/assays/V2Assays/conversions';

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

// Expected window - based on Advanced Settings in the modal (Scheduling and Grouping - see AssayConfig.tsx for start, interval, and width)
export const createAssay = (assayConfiguration = {}, baselineSummary = null, selectedEdgeNames=null, isAssaysV2Enabled = false) => {
  const assayConfig = { ...assayConfiguration };

  if (assayConfig?.window) {
    assayConfig.window.end = undefined;
    assayConfig.window.path = assayConfiguration.getIOPath();
  }
  if (baselineSummary) {
    assayConfig.baseline = { static: baselineSummary }
  }

  let body;
  let path;
  /**
   * @deprecated Assays V1 Logic
   */
  if (isAssaysV2Enabled) {
    body = JSON.stringify(get_schedule_request(assayConfig, baselineSummary));
    path = 'v2/api/assays/schedule'
  } else {
    body = JSON.stringify(assayConfig)
    path = 'v1/api/assays/create'
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body
  };

  return postToApi(path, fetchOptions)
}

export default createAssay;
